import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { INCIDENT_API } from "./apiRoutes";

interface UseGetIncidentDashboardCountProps {
  communityId: string;
  userId?: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getIncidentDashboardCount = async (
  communityId: string,
  userId?: string
) =>
  await axiosAuth.get(
    `${INCIDENT_API(communityId)}/dashboard/count?communityId=${communityId}${
      userId ? "&userId=" + userId : ""
    }`
  );

const useGetIncidentDashboardCount = ({
  queryParams,
  communityId,
  userId,
}: UseGetIncidentDashboardCountProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["incident-dashboard-count", communityId],
    queryFn: () => getIncidentDashboardCount(communityId, userId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!communityId || queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetIncidentDashboardCount;
